<template>
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7461 5.45313C19.8984 5.33203 20.125 5.44531 20.125 5.63672V13.625C20.125 14.6602 19.2852 15.5 18.25 15.5H2C0.964844 15.5 0.125 14.6602 0.125 13.625V5.64063C0.125 5.44531 0.347656 5.33594 0.503906 5.45703C1.37891 6.13672 2.53906 7 6.52344 9.89453C7.34766 10.4961 8.73828 11.7617 10.125 11.7539C11.5195 11.7656 12.9375 10.4727 13.7305 9.89453C17.7148 7 18.8711 6.13281 19.7461 5.45313ZM10.125 10.5C11.0313 10.5156 12.3359 9.35938 12.9922 8.88281C18.1758 5.12109 18.5703 4.79297 19.7656 3.85547C19.9922 3.67969 20.125 3.40625 20.125 3.11719V2.375C20.125 1.33984 19.2852 0.5 18.25 0.5H2C0.964844 0.5 0.125 1.33984 0.125 2.375V3.11719C0.125 3.40625 0.257812 3.67578 0.484375 3.85547C1.67969 4.78906 2.07422 5.12109 7.25781 8.88281C7.91406 9.35938 9.21875 10.5156 10.125 10.5Z"
      fill="currentColor"
    />
  </svg>
</template>
